(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon', [
        'uwAgenda.global',
        'uwAgenda.tasks'
    ]);

    // constants
    module.constant('ProtocolFilter', {
        "ShowAlwaysOnLoad": "showAlwaysOnLoad",
        "ShowInAgenda": "showInAgenda",
        "ShowInSidebar": "showInSidebar",
        "ShowOnAgendaChange": "showOnAgendaChange",
        "ShowOnAppointmentCopy": "showOnAppointmentCopy",
        "ShowOnAppointmentCut": "showOnAppointmentCut",
        "ShowOnAppointmentDelete": "showOnAppointmentDelete",
        "ShowOnAppointmentSave": "showOnAppointmentSave",
        "ShowOnDayTaskAdd": "showOnDayTaskAdd",
        "ShowOnInboundCall": "showOnInboundCall",
        "ShowOnNewPatientSelection": "showOnNewPatientSelection",
        "ShowOnNewPatientNotAllowed": "showOnNewPatientNotAllowed",
        "ShowOnOutboundCall": "showOnOutboundCall",
        "ShowOnTransferCall": "showOnTransferCall",
        "ShowOnAppointmentView": "showOnAppointmentView"
    });

    module.constant('ProtocolBroadcast', {
        "Show": "protocol:show",
        "Closed": "protocol:closed"
    });    
})();